import React, { PropsWithChildren, ReactElement } from 'react';

import { ThreadPreview } from '@pb/shared/ui/molecules/thread-preview';

import { addressFormatter } from '../../../helpers/address-formatter';
import { dateFormatter, getParticipantsNames } from '../../../helpers';
import { TThreadProperties } from './thread-list.types';

export function ThreadList({
    user,
    thread,
    currentThreadId,
}: PropsWithChildren<TThreadProperties>): ReactElement {
    if (!thread) {
        return <li className="absent-node-in-db" />;
    }

    const participantsNames = getParticipantsNames(
        user,
        thread?.participantsDetails
    );

    const humanFriendlyDate = dateFormatter(
        thread?.lastMessage ? thread?.lastMessage.date : ''
    );

    const latestMessage = thread?.lastMessage.body;

    const isActiveThread = currentThreadId === thread.id;

    // Check if there are any unread messages
    const isUnread = () => {
        const isOtherUser = thread?.lastMessage.senderId !== user?.id;
        const isMessageRead = thread?.lastMessage.read;
        if (thread?.lastMessage && isOtherUser) {
            if (!isMessageRead) {
                return true;
            }
        }
        return false;
    };

    return (
        <li>
            <ThreadPreview
                key={thread.id}
                name={participantsNames}
                address={addressFormatter(thread)}
                time={humanFriendlyDate}
                unread={isUnread()}
                active={isActiveThread || false}
                href={`/${thread.id}`}
            >
                {latestMessage}
            </ThreadPreview>
        </li>
    );
}
